export default __webpack_public_path__ + "static/media/ban-m.99a83192.svg";